<template>
  <div>
    <b-navbar v-if="isLoggedIn" :fixed-top="true" class="shdw">
      <template slot="brand">
        <b-navbar-item @click="$nav.home">
          <img :src="navbarLogo" alt="TripCircuit wired for Gant Travel Management" />
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item v-if="$globals.profile.firstName" class="is-hidden-desktop">
          <b class="is-block">{{ $globals.profile.firstName }} {{ $globals.profile.lastName }}</b>
          <b class="secondary-text">{{ $globals.profile.email }}</b>
        </b-navbar-item>
        <b-navbar-item v-if="this.$route.path !== '/home'" class="navbar-item-label" @click="$nav.home">
          Home
        </b-navbar-item>
        <b-navbar-item v-if="showItinerary" class="bookingDropdownTrigger">
          <SmallItinerarySidebar :sol="solutionAll"
            :key="solutionAll.flight.key + solutionAll.hotel.key + solutionAll.car.key" />
        </b-navbar-item>
        <b-navbar-item v-else class="navbar-item-label" @click="$nav.searchGo">
          Book Trip
        </b-navbar-item>
        <b-navbar-item v-if="$globals.profile.firstName" class="navbar-item-label" @click="$nav.tripsGo">
          My Trips
        </b-navbar-item>
        <!-- Travel Admin-->
        <b-dropdown v-if="$globals.profile.isTravelChampion" append-to-body aria-role="menu" position="is-bottom-left" class="is-hidden-touch">
          <a slot="trigger" role="button" class="navbar-item">
            <b class="is-block">Travel Admin</b>
          </a>
          <b-dropdown-item aria-role="menuitem" @click="$nav.accountSettingsGo">
            <b class="is-block gant-text">Account Settings</b>
          </b-dropdown-item>
          <b-dropdown-item aria-role="menuitem" @click="$nav.manageUsersGo">
            <b class="is-block gant-text">Manage Users</b>
          </b-dropdown-item>
          <b-dropdown-item aria-role="menuitem" @click="$nav.manageTravelPolicies">
            <b class="is-block gant-text">Manage Travel Policies</b>

          </b-dropdown-item>

              <b-dropdown-item
             v-if="$globals.profile && $globals.profile.features && $globals.profile.features['account.trip_library.access']"
            aria-role="menuitem"
            @click="$nav.tripLibraryGo"
    >
      <b class="is-block gant-text">Trip Library</b>
    </b-dropdown-item>

        </b-dropdown>
        <!-- End Travel Admin -->
        <b-navbar-item class="navbar-item-label is-hidden-desktop" @click="$nav.travelersGo">
          My Travelers
        </b-navbar-item>
        <!-- <b-navbar-item class="navbar-item-label is-hidden-desktop" @click="$nav.manageTravelPolicies">
          Travel Policy Manager
        </b-navbar-item> -->
        
        <UserNeedHelpDropdown />
        <b-dropdown append-to-body aria-role="menu" position="is-bottom-left" class="is-hidden-touch">
          <a slot="trigger" role="button" class="navbar-item">
            <b-icon icon="account-circle" />
          </a>
          <b-dropdown-item custom aria-role="menuitem">
            <b class="is-block gant-text">{{ $globals.profile.firstName }} {{ $globals.profile.lastName }}</b>
            <b class="secondary-text">{{ $globals.profile.email }}</b>
            <hr class="dropdown-divider" aria-role="menuitem" />
          </b-dropdown-item>
          <!-- <b-dropdown-item aria-role="menuitem" @click="$nav.searchGo">
            <b class="is-block gant-text">Book Trip</b>
          </b-dropdown-item>
          <b-dropdown-item v-if="$globals.profile.firstName" aria-role="menuitem" @click="$nav.tripsGo">
            <b class="is-block gant-text">My Trips</b>
          </b-dropdown-item> -->
          <b-dropdown-item aria-role="menuitem" @click="$nav.travelersGo">
            <b class="is-block gant-text">My Travelers</b>
          </b-dropdown-item>
          <hr class="dropdown-divider" aria-role="menuitem" />
          <b-dropdown-item value="$app.logout" aria-role="menuitem" @click="$nav.out">
            <b-icon icon="logout" />
            <span class="krungthep">Logout</span>
          </b-dropdown-item>
        </b-dropdown>
        <b-navbar-item href="https://www.gantgateway.com/profile" target="_blank" class="customImageLink">
          <img src="/images/logo-1024x454.png" alt="visit Gant Gateway" />
          <img src="/images/Go_Icon.png" class="ml-2" alt="Visit Gant Gateway" />
        </b-navbar-item>
        <b-navbar-item v-if="$globals.profile.firstName" class="is-hidden-desktop krungthep" @click="$nav.out">
          Logout
        </b-navbar-item>
      </template>
    </b-navbar>
    <div v-if="previewMode">
      <div
        class="notification has-text-centered is-size-7 is-success"
        :style="{
          margin: 0,
          position: 'fixed',
          top: isLoggedIn ? '60px' : '0px',
          width: '100%',
          'z-index': 10,
          padding: '5px 1rem 5px 1rem'
        }"
      >
        <div class="columns">
          <div class="column">
            You are currently in <strong>Demo</strong> mode.
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoggedIn && pathMixin_isBookingPageWithoutTravelerBar">
      <div v-if="$globals.travellers.set && !$route.path.match(/(^\/meetings)/)"
        class="notification has-text-centered is-size-7"
        :style="{
          margin: 0,
          position: 'fixed',
          top: previewMode === 'success' ? '90px' : '60px',
          width: '100%',
          'z-index': 10, // Enclose the key 'z-index' in quotes to avoid syntax error
          padding: '5px 1rem 5px 1rem',
          background: '#f8eacf'
        }">
        <div class="columns">
          <div class="column">
            <span class="bookingVerbDesktop">You are now booking </span>
            <span class="bookingVerbMobile">Booking </span>
            <strong>{{ $globals.travellers.tripType }}</strong> travel for
            <strong>
              {{
                $globals.travellers.bookFor === "others"
                ? `${currentTravellerProfile.firstName} ${currentTravellerProfile.lastName}`
                : "yourself"
              }}
            </strong>
            <a class="ml-4 is-small is-size-7" @click="openCardModal">Change</a>
          </div>
        </div>
      </div>
    </div>

   <!-- Chat Component -->
      <Chat v-if="isChatVisible"
        :key="chatKey" 
        :isChatAllowed="isLoggedIn"
        :salesforceContactId="travelProfile.id"
        :userEmail="travelProfile.email"
         ref="chatComponent"
      />
</div>
</template>

<script>
import bookingMixin from "../../mixins/bookingMixin";
import TravellerModal from "../Traveller/TravellerModal.vue";
import UserNeedHelpDropdown from "../User/UserNeedHelpDropdown";
import SmallItinerarySidebar from "../Itinerary/SmallItinerarySidebar";
import Chat from "../Chat/Chat.vue";

export default {
  name: "MainNavBar",
  mixins: [bookingMixin],
  components: {
    UserNeedHelpDropdown,
    SmallItinerarySidebar,
    Chat
  },
  data() {
    return {
      page: 1,
      data: [],
      totalPages: 1,
      selected: null,
      isFetching: false,
      chatKey: 0,
      isChatVisible: false,
    };
  },
  computed: {
    isLoggedIn() {
      return Object.keys(this.$globals.profile).length > 0;
    },
    travelProfile() {
      // Get the active user profile from the Vuex store
      return this.$store.getters["app/getActiveUser"];
    },
    currentTravellerProfile() {
      return this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"];
    },
    navbarLogo() {
      const defaultUrl = "/images/TripCircuit-Logo-white.png";
      const configUrl = this.$globals.profile?.tripCircuitConfiguration?.logoUrl || "";

      return configUrl || defaultUrl;
    },
    previewMode() {
        return this.$appConfig.previewMode;
    },
    showItinerary() {
      if (this.$store.state.bookTravel.atc?.useAtcShopper) {
        return false;
      }
      return this.bookTrip.currentlyBooking;
    },
  },
  methods: {
    initializeChat() {
      this.isChatVisible = true;
      this.chatKey++; // Force reinitialization
    },
    destroyChat() {
      this.isChatVisible = false;
      // Explicitly reset Chat instance if needed
      const chatInstance = this.$refs.chatComponent;
      if (chatInstance && typeof chatInstance.reset === "function") {
        chatInstance.destroy();
      }
    },
    openCardModal() {
      this.$buefy.modal.open({
        width: 700,
        parent: this,
        trapFocus: false,
        hasModalCard: true,
        component: TravellerModal,
        props: { profile: this.$globals.profile },
      });
    },
  },
  mounted() {
    if (this.isLoggedIn) {
      this.initializeChat();
    }
  
 
  this.$root.$on("openChatWindow", () => {
    if (this.$refs.chatComponent) {
      // Wait for chat initialization before opening it
      if (this.$refs.chatComponent.webchat) {
        this.$refs.chatComponent.webchat.selfHostedApp.open();
      } else {
        console.warn("Webchat is not initialized yet. Initializing now...");
        this.$refs.chatComponent.initializeChat();
        setTimeout(() => {
          if (this.$refs.chatComponent.webchat) {
            this.$refs.chatComponent.webchat.selfHostedApp.open();
          } else {
            console.error("Failed to initialize chat.");
          }
        }, 1000);
      }
    } else {
      console.error("Chat component reference not found.");
    }
  });

},


watch: {
    isLoggedIn(newValue) {
      console.log("Login state changed:", newValue);
      if (newValue) {
        this.initializeChat();
      } else {
        this.destroyChat();
      }
    },
  },
};
</script>
